import crypto from 'crypto-js';
import * as Sentry from '@sentry/react';
import queryString from 'query-string';

const LOCALSTORAGE_KEY = 'app';
const LOCALSTORAGE_SECRET = 'skilleto';

const useEncryption = process.env.NODE_ENV === 'production';

const persistStateToStorage = (data) => {
  if (useEncryption) {
    const crypted = crypto.AES.encrypt(JSON.stringify(data), LOCALSTORAGE_SECRET).toString();
    localStorage.setItem(LOCALSTORAGE_KEY, crypted);
  } else {
    localStorage.setItem(LOCALSTORAGE_KEY, JSON.stringify(data));
  }
};

export const loadPersistedState = () => {
  // impersonification
  try {
    const params = queryString.parse(window.location.search) || {};
    if (params.token) {
      const state = {
        auth: {
          ...JSON.parse(window.atob(params.token)),
          error: null,
          // language: 'cs',
          loading: false,
          loggedIn: true,
          loggingIn: false,
          submitting: false
        }
      };
      persistStateToStorage(state);
      return state;
    }
  } catch (err) {
    Sentry.captureException(err);
  }

  const state = localStorage.getItem(LOCALSTORAGE_KEY);
  if (state !== null) {
    try {
      if (useEncryption) {
        const bytes = crypto.AES.decrypt(state, LOCALSTORAGE_SECRET);
        return JSON.parse(bytes.toString(crypto.enc.Utf8));
      }
      return JSON.parse(state);
    } catch {
      Sentry.captureMessage(`Cannot parse persisted state: ${state}`);
      return null;
    }
  }

  return null;
};

export const persistState = (dataOrFn) => {
  const data = typeof dataOrFn === 'function' ? dataOrFn(loadPersistedState()) : dataOrFn;
  persistStateToStorage(data);
};

export const clearPersistedState = () => localStorage.removeItem(LOCALSTORAGE_KEY);

export default {
  loadPersistedState,
  persistState,
  clearPersistedState
};
